import request from '@/utils/request.js'

/***短信列表***/
export function getSMSList(data){
    return request({
        url: 'sim/supplier/sendSms/lit',
        method: 'post',
        data
    })
}



/***发送短信***/
export function sendSMS(data){
    return request({
        url: 'sim/supplier/sendSms/send',
        method: 'post',
        data
    })
}

/***获取短信模板列表***/
export function getSmsTemplateList(data){
    return request({
        url: 'sim/supplier/select/list',
        method: 'post',
        data
    })
}

/***新增短信模板***/
export function addSmsTemplat(data){
    return request({
        url: 'sim/supplier/add/module',
        method: 'post',
        data
    })
}

/***更新短信模板***/
export function updateSmsTemplat(data){
    return request({
        url: 'sim/supplier/update/module',
        method: 'post',
        data
    })
}


/***删除短信模板***/
export function deleteSmsTemplate(data){
    return request({
        url: 'sim/supplier/delete/module',
        method: 'post',
        data
    })
}


/***短信统计***/
export function getSmsStatistics(data){
    return request({
        url: 'sim/supplier/sms/statistics',
        method: 'post',
        data
    })
}

